export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/worker-legacy.5e769269.worker.js");
}
